import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import EditCaseForm from './EditProjectForm'; // Import your EditCaseForm component
import {toast } from "react-toastify";


function Projects({ cases = [], fetchCases }) {
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);

  // Get user role from local storage
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role || ""; // Assuming "role" is stored in user object

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this project?")) return;
  
    const token = localStorage.getItem("token");
  
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/Projects/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
     ;
      toast.success("project deleted successfully!");

      if (fetchCases) fetchCases(); // refresh the list
    } catch (error) {
      console.error("Error deleting project:", error);
      toast.error("Failed to delete the project.");


    }
  };

  const handleSendTermination = async (id) => {
    if (!window.confirm("Send termination notice for this project?")) return;

    const token = localStorage.getItem("token");
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/Projects/${id}/send-termination`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
      toast.success("Termination notice sent.");
      if (fetchCases) fetchCases();
    } catch (error) {
      console.error("Error sending termination notice:", error);
      toast.error("Failed to send termination notice.");
    }
  };
  
  const openEditPopup = (caseItem) => {
    setSelectedCase(caseItem);
    setShowEditPopup(true); // Show the Edit Case popup
  };

  const closeEditPopup = () => {
    setShowEditPopup(false); // Close the popup
    setSelectedCase(null); // Clear the selected case
  };

  if (!cases.length) {
    return <div className="text-white">No Projects found.</div>;
  }

  return (
    <div className="space-y-4">
   

      {cases.map((caseItem) => (
        <div
          key={caseItem._id}
          className="flex flex-col md:flex-row items-start bg-white rounded-xl shadow-md border border-gray-200 p-4 gap-4"
        >
          <div className="flex-shrink-0 w-full md:w-1/4 h-24 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-sm">
            📄 Project
          </div>

          <div className="flex-1">
          <Link to={`/cases/${caseItem._id}`}>
            <h2 className="text-xl font-semibold mb-1">
              {caseItem.caseTitle || 'Untitled Case'}
            </h2>
            <p className="text-gray-600 mb-1">
              <span className="font-medium">Client:</span> {caseItem.client?.clientName}
            </p>
            <p className="text-gray-600 mb-1">
              <span className="font-medium">Project Type:</span> {caseItem.caseType}
            </p>
            <p className="text-gray-600">
              <span className="font-medium">Hearing Date:</span> {caseItem.hearingDate}
            </p>
              </Link>
          </div>
  {/* Conditionally show Edit and Delete for non-developers */}
          {userRole !== 'Developer' && (
          <div className="flex flex-col gap-2">
            <button
              onClick={() => openEditPopup(caseItem)}
              className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 text-sm"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(caseItem._id)}
              className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 text-sm"
            >
              Delete
            </button>
            <button
              onClick={() => handleSendTermination(caseItem._id)}
              className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 text-sm"
            >
              Send Termination notice
            </button>
          </div>
          )}
        </div>
          
      ))}

      {showEditPopup && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
            <EditCaseForm closeModal={closeEditPopup} caseData={selectedCase} onProjectUpdated={fetchCases} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Projects;
